<template>
  <div>
    <naj-box :title="local.bankruptcy.secretaryForm.title">
      <identity-verification-form
        :form-model="formModel"
        :person-title="local.bankruptcy.secretaryForm.name"
        :persons-only="true"
        :saudi-only="true"
        :is-optional="!isRequired"
        :view-mode="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.secretaryDetailsConfirmation}`] && isNotCompleted )"
        :manager-social-id-required="false"
      ></identity-verification-form>
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.number"
            :label="local.bankruptcy.secretaryForm.licenceNumber"
            :value.sync="formModel.secretaryLicenceNumber"
            :validates="`max:50${isRequired?'|required':''}`"
            :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.secretaryDetailsConfirmation}`] && isNotCompleted )"
          ></naj-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.secretaryDetailsConfirmation"></audit-confirmation-flag-checkbox>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { partyTypeEnum } from '@/helpers/enum';
import { legalCapacitiesEnum, mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
import IdentityVerificationForm from '@/modules/bankruptcy/components/request/identity-verification-form.vue';
import AuditConfirmationFlagCheckbox from '@/modules/bankruptcy/components/request/audit-confirmation-flag-checkbox';

const { mapState, mapGetters, mapActions, mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');
export default {
  name: 'SecretaryForm',
  inject: ['$validator'],
  components: {
    IdentityVerificationForm,
    AuditConfirmationFlagCheckbox,
  },
  data() {
    return {
      partyTypeEnum,
      legalCapacitiesEnum,
      mainRequestAuditFlag,
      requestStatusEnum,
    };
  },
  computed: {
    ...mapLUTState([]),
    ...mapState({
      formModel: state => state.secretary,
      mainRequest: state => state.mainRequest,
      auditConfirmations: state => state.auditConfirmations,
    }),
    isRequired() {
      return this.formModel.secretaryLicenceNumber || this.formModel.identityNumber;
    },
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
    requestObjectKey() {
      return this.$route.params.objectKey;
    },

  },
  created() {
    this.getRequestSecretaries(this.requestObjectKey);
  },
  methods: {
    ...mapActions([
      'getRequestSecretaries',
    ]),
  },
};
</script>

<style lang="scss">
</style>
